import React from "react";
import { connect } from "react-redux";
import {
  getContactType,
} from "../../../actions";
import hoistNonReactStatics from 'hoist-non-react-statics'


let loaded = false;

export const withContactType = (WrapperComponent) => {
  class WithContactType extends React.Component {
    componentDidMount() {
      const { getContactType } = this.props;
      if (loaded) return;
      loaded = true;
      getContactType();
    }
    getContactTypeOptions = () => undefined
    getContactTypeLocaleOptions = () => {
      const { contactType } = this.props;
      return contactType.map(({ created_at, ...rest }) => ({ ...rest }));
    }
    render() {
      return (
        <WrapperComponent 
          contactTypeOptions={this.getContactTypeOptions()} 
          contactTypeLocaleOptions={this.getContactTypeLocaleOptions()} 
          {...this.props} 
        />
      )
    }
  }
  const mapStateToProps = ({ contactType }) => ({ contactType })
  const WithContactTypeHOC = connect(mapStateToProps, {
    getContactType,
  })(WithContactType);
  hoistNonReactStatics(WithContactTypeHOC, WrapperComponent)
  return WithContactTypeHOC
}
